import React from 'react';
import PropTypes from 'prop-types';
import useUserContext from 'Context/UserContext';
import {
  STATE_LOADING,
  STATE_SET_REFRESH_LINK,
  STATE_SET_SUMMARY_COLLECTION,
  STATE_SET_ACCOUNT_SUMMARY_RESOURCE,
  STATE_SET_INVESTIGATION_RESOURCE,
  STATE_SET_ACH_RELATIONSHIP_RESOURCE,
  initiallyFetchAccountRequestsCollection,
  fetchResourcesFromURLParams,
} from './ApexAdminPortalActions';

const ApexAdminPortalStateContext = React.createContext(undefined);
const ApexAdminPortalDispatchContext = React.createContext(undefined);

const defaultState = {
  error: null,
  loading: null,
  refreshLink: null,
  accountSummaryCollection: null,
  accountSummaryResource: null,
  investigationResource: null,
  achRelationshipResource: null,
};

function init(state) {
  return {
    ...defaultState,
    ...state,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case STATE_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }

    //  SET
    case STATE_SET_REFRESH_LINK: {
      return {
        ...state,
        refreshLink: action.link,
      };
    }
    case STATE_SET_SUMMARY_COLLECTION: {
      return {
        ...state,
        accountSummaryCollection: action.collection,
        loading: false,
      };
    }
    case STATE_SET_ACCOUNT_SUMMARY_RESOURCE: {
      return {
        ...state,
        accountSummaryResource: action.resource,
      };
    }
    case STATE_SET_INVESTIGATION_RESOURCE: {
      return {
        ...state,
        investigationResource: action.resource,
      };
    }
    case STATE_SET_ACH_RELATIONSHIP_RESOURCE: {
      return {
        ...state,
        achRelationshipResource: action.resource,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
function ApexAdminPortalProvider({ children, initialState }) {
  const [state, dispatch] = React.useReducer(reducer, initialState, init);
  const { userResource } = useUserContext();

  React.useEffect(() => {
    initiallyFetchAccountRequestsCollection(userResource, dispatch, state);
  }, [userResource]);

  React.useEffect(() => {
    fetchResourcesFromURLParams(dispatch);
  }, []);

  return (
    <ApexAdminPortalStateContext.Provider value={state}>
      <ApexAdminPortalDispatchContext.Provider value={dispatch}>
        {children}
      </ApexAdminPortalDispatchContext.Provider>
    </ApexAdminPortalStateContext.Provider>
  );
}

function useApexAdminPortalStateContext() {
  const context = React.useContext(ApexAdminPortalStateContext);

  if (context === undefined) {
    throw new Error('useApexAdminPortalStateContext must be used within a ApexAdminPortalProvider');
  }

  return context;
}

function useApexAdminPortalDispatchContext() {
  const context = React.useContext(ApexAdminPortalDispatchContext);

  if (context === undefined) {
    throw new Error('useApexAdminPortalDispatchContext must be used within a ApexAdminPortalProvider');
  }

  return context;
}

ApexAdminPortalProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  initialState: PropTypes.object.isRequired,
};

export {
  ApexAdminPortalProvider,
  useApexAdminPortalStateContext,
  useApexAdminPortalDispatchContext,
};
